import store from '@/state/store'

export default [
    {
        path: '/blank',
        name: 'Blank',
        meta: {
            authRequired: false,
            authorization: []
        },
        component: () => import('../views/layouts/blank')
    },
    {
        path: '/main',
        name: 'Dashboard',
        meta: {
            authRequired: true,
            authorization: ['USER', 'ADMIN']
        },
        component: () => import('../views/pages/dashboard/indexDashboard.vue')
    },
    {
        path: '/station-status',
        name: 'StationStatus',
        meta: {
            authRequired: true,
            authorization: ['USER', 'ADMIN']
        },
        component: () => import('../views/pages/status/indexStatus.vue')
    },




    {
        path: '/demand-manage',
        name: 'DemandManage',
        meta: {
            authRequired: true,
            authorization: ['USER', 'ADMIN']
        },
        component: () => import('../views/pages/demand/indexDemand.vue')
    },




    {
        path: '/ocpp/configuration',
        name: 'Configuration',
        meta: {
            authRequired: true,
            authorization: ['OCPP']
        },
        component: () => import('../views/pages/ocpp/configuration/index.vue')
    },
    {
        path: '/ocpp/operations',
        name: 'Operations',
        meta: {
            authRequired: true,
            authorization: ['OCPP']
        },
        component: () => import('../views/pages/ocpp/operations/index.vue')
    },
    {
        path: '/ocpp/monitoring',
        name: 'Monitoring',
        meta: {
            authRequired: true,
            authorization: ['OCPP']
        },
        component: () => import('../views/pages/ocpp/monitoring/index.vue')
    },
    {
        path: '/driver-recommend',
        name: 'DriverRecommend',
        meta: {
            authRequired: true,
            authorization: ['USER', 'ADMIN']
        },
        component: () => import('../views/pages/driver/index.vue')
    },




    {
        path: '/',
        name: 'Home',
        redirect: '/station',
        meta: {
            authRequired: false,
            authorization: []
        },
        component: () => import('../views/layouts/blank')
    },
    {
        path: '/station',
        name: 'EvMap',
        meta: {
            authRequired: false,
            authorization: []
        },
        component: () => import('../views/pages/maps/evMap.vue')
    },
    {
        path: '/maps-demo',
        name: 'EvMapDemo',
        redirect: '/station',
        meta: {
            authRequired: false,
            authorization: []
        },
        component: () => import('../views/layouts/blank')
    },


    /*{
        path: '/region',
        name: 'StationMap',
        meta: {
            authRequired: true,
            authorization: ['USER', 'ADMIN']
        },
        //component: () => import('../views/pages/dashboard/index-lh')
        component: () => import('../views/pages/station/indexStation.vue')
    },*/

    // 여기서 부터 새로 고침








    {
        path: '/statistics-report',
        name: 'StatisticsReport',
        meta: {
            authRequired: true,
            authorization: ['USER', 'ADMIN']
        },
        component: () => import('../views/pages/statistics/index')
    },
    {
        path: '/manage',
        name: 'ServiceManage',
        meta: {
            authRequired: true,
            authorization: ['ADMIN']
        },
        component: () => import('../views/pages/manage/index')
    },






    // 하위 메뉴 확인 필요
    // {
    //     path: '/manage/fee-add',
    //     name: 'Manage Add Fee',
    //     meta: {
    //         authRequired: true,
    //         authorization: ['ADMIN']
    //     },
    //     component: () => import('../views/pages/manage/Manage_Fee_Add')
    // },
    // {
    //     path: '/manage/fee-update/:id',
    //     name: 'Manage Update Fee',
    //     meta: {
    //         authRequired: true,
    //         authorization: ['ADMIN']
    //     },
    //     props: true,
    //     component: () => import('../views/pages/manage/Manage_Fee_Update')
    // },
    {   /* MDK-OAuth Redirector. */
        path: '/oauth2/redirect',
        name: 'Auth Handler',
        meta: {
            authRequired: false
        },
        component: () => import('../mdk/OAuth2RedirectHandler')
    },
    { path: '/oauth/google/index' },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        /*meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({
                        name: 'home'
                    })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },*/
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/pages/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({
                        name: 'home'
                    })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({
                        name: 'home'
                    })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            /*beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? {
                    name: 'home'
                } : {
                    ...routeFrom
                })
            },*/
        },
    }
]
